import React from "react";

// Glowing gradient orb mascot – reusable
export function MascotOrb({ size = 96, className = "", speaking = false }) {
  const s = `${size}px`;
  return (
    <div
      className={`relative inline-flex items-center justify-center ${className}`}
      style={{ width: s, height: s }}
      aria-hidden="true"
      data-testid="mascot-orb"
    >
      {/* Outer halo */}
      <div
        className="absolute inset-[-18%] rounded-full blur-2xl opacity-70"
        style={{
          background:
            "radial-gradient(closest-side, rgba(99,102,241,0.55), rgba(59,130,246,0.25) 55%, transparent 75%)",
        }}
      />
      {/* Rotating ring */}
      <div className="absolute inset-[-6%] rounded-full orbit-ring animate-slow-spin" />
      {/* Core gradient */}
      <div
        className="relative rounded-full animate-soft-pulse"
        style={{
          width: "100%",
          height: "100%",
          background:
            "radial-gradient(circle at 30% 28%, #ffffff 0%, #bfdbfe 18%, #818cf8 55%, #6d28d9 100%)",
          boxShadow:
            "inset 0 -14px 30px rgba(30,27,75,0.35), inset 0 10px 20px rgba(255,255,255,0.55), 0 18px 40px -10px rgba(79,70,229,0.45)",
        }}
      >
        {/* Specular highlight */}
        <div
          className="absolute rounded-full"
          style={{
            top: "14%",
            left: "18%",
            width: "38%",
            height: "28%",
            background:
              "radial-gradient(ellipse at center, rgba(255,255,255,0.9), transparent 70%)",
            filter: "blur(2px)",
          }}
        />
        {/* Tiny iris */}
        <div
          className="absolute"
          style={{
            top: "42%",
            left: "40%",
            width: "20%",
            height: "20%",
            borderRadius: "9999px",
            background:
              "radial-gradient(circle, rgba(255,255,255,0.95), rgba(191,219,254,0.7) 55%, rgba(99,102,241,0) 70%)",
          }}
        />
      </div>

      {/* Speaking waveform */}
      {speaking && (
        <div
          className="absolute -bottom-3 left-1/2 -translate-x-1/2 flex items-end gap-[3px]"
          data-testid="mascot-speaking-wave"
        >
          {[0, 1, 2, 3, 4, 5].map((i) => (
            <span
              key={i}
              className="wave-bar"
              style={{ animationDelay: `${i * 0.12}s` }}
            />
          ))}
        </div>
      )}
    </div>
  );
}

export default MascotOrb;
